import { render, staticRenderFns } from "./EmployersItem.vue?vue&type=template&id=3d0aeaa4&scoped=true"
import script from "./EmployersItem.vue?vue&type=script&lang=js"
export * from "./EmployersItem.vue?vue&type=script&lang=js"
import style0 from "./EmployersItem.vue?vue&type=style&index=0&id=3d0aeaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0aeaa4",
  null
  
)

export default component.exports